import React, { useState, useContext, useCallback, useEffect } from "react";
import "./AccessCodeRegisterActiveHub.scss";
import { Button, RedeemCodeInput, Loader } from "@activehub/common-components-spa-resource";
import { accessCodeRedeemption, getAccessCodeData } from "../../network/ApiService";
import { AppContext } from '../../App';
import {
  ErrorPopUp
} from "../../components";

const AccessCodeActiveHub = (props) => {
  const [accessCode, setAccessCode] = useState('');
  const [loading, setLoading] = useState(false);
  const [isCodeValid, setIsCodeValid] = useState("");
  const [isError, setIsError] = useState(false);
  const [isEmpty, setIsEmpty] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [toolTip, setToolTip] = useState(false);
  const [btnClicked, setBtnClicked] = useState(false);
  const [openErrorPopup, setErrorPopup] = useState(false);
  const [isbtnDisabled, setIsbtnDisabled] = useState(false);
  const [ebookTitle, setEbookTitle] = useState('')
  const [errpopMsg, setErrpopMsg] = useState("We are unable to activate the access code. Please try again after sometime.");

  const {
    setRedeemedResponse
  } = useContext(AppContext);

  const HTMLEntities = require('html-entities');
  
  const Entities = ('AllHtmlEntities' in HTMLEntities) ? HTMLEntities.AllHtmlEntities : function () {
    this.encode = HTMLEntities.encode;
    this.decode = HTMLEntities.decode;
    this.decodeEntity = HTMLEntities.decodeEntity;
  
    return this;
  }
  const entities = new Entities();

  let handleOutSideClick = useCallback((e) => {
    if (!e?.target.className.includes('form-control form__input')) {
      const codeInputValue = document.querySelector('.redeem-code-input .form__input')?.value || "";
     if(codeInputValue !== "" && codeInputValue.length < 35){
        setIsError(true);
        setIsCodeValid(false);
        setToolTip(false);
        setErrorMsg("This code is not valid. Please enter a different code.");
      }
    }
    if (!e?.target.className.includes('next-step')) {
      setToolTip(false);
    }
  }, []);

    useEffect(function () {
    let currentElement = document?.activeElement;
    let timerId = null;
    timerId = setTimeout(function () {
      if (currentElement) {
        document.addEventListener('click', handleOutSideClick);
      }
    }, 0);
    return function () {
      clearTimeout(timerId);
      document.removeEventListener('click', handleOutSideClick);
    };
  }, [handleOutSideClick]);


  const formatLastSyncdate = (lastSync)=>{
      function pad(s) {
      return s < 10 ? "0" + s : s;
      }
      var date = new Date(lastSync);

      var hours = date.getHours();
      var minutes = date.getMinutes();
      var ampm = hours >= 12 ? "PM" : "AM";
      hours = hours % 12;
      hours = hours ? hours : 12; // the hour '0' should be '12'
      minutes = minutes < 10 ? "0" + minutes : minutes;
      var strTime = hours + ":" + minutes + " " + ampm;
      return `${[
      pad(date.getDate()),
      pad(date.getMonth() + 1),
      date.getFullYear(),
      ].join("/")}`;
    }

  const validateAccessCode = () => {
    setBtnClicked(false);
    if (accessCode == '') {
      setIsEmpty(true);
      setErrorMsg("Please enter an access code.");
      setIsCodeValid(false);
      setToolTip(true);
    }else if(accessCode !== '' && accessCode.length < 35){
      setIsError(true);
      setIsCodeValid(false);
      setToolTip(false);
      setErrorMsg("This code is not valid. Please enter a different code.");
    }else {
      // regexValidation(accessCode);
      setLoading(true);
       let payload = {
            userName: window.USERPROFILE?.userName || "",
            firstName: window.USERPROFILE?.firstName || "",
            lastName: window.USERPROFILE?.lastName || "",
            emailId: window.USERPROFILE?.email || "",
            role: window.USERPROFILE?.role || "Learner",
            yearGroup:"Year 7"
        }
      accessCodeRedeemption(accessCode, [payload]).subscribe(
        (response) => {
          const expiryDate = new Date(response[0]?.startDate);
          expiryDate.setFullYear(0 + response[0]?.expiryYear);
          const formattedObj = {
            accessCode: response[0]?.accessCode,
            subscriptionId: response[0]?.subscriptionId,
            startDate: formatLastSyncdate(response[0]?.startDate),
            endDate: formatLastSyncdate(expiryDate),
            ebookTitle: entities?.decode(ebookTitle),
            expireDate:response[0]?.expireDate
          }
          setRedeemedResponse(formattedObj);
          setLoading(false);
          // clear the local storage.
          localStorage.removeItem('orgDetailsByUser');
          props.onNextStep();         
        },
        (error) => {
          if((error?.data?.status == 404 && error?.data?.detail == 'INTEGRATION_API_ERROR') || error?.data?.status == 500) {
            setErrpopMsg("We are unable to activate the access code. Please try again after sometime.");
          }else if(error?.data?.users?.[0]?.status == 409 && error?.data?.status == 400) {
            setErrpopMsg(error?.data?.users?.[0].statusDetails);
          }else if(error?.data?.status == 400 && !(error?.data?.users?.[0]?.status == 409)) {
            setErrpopMsg(error?.data?.detail);
          }else {
            setErrpopMsg(error?.data?.detail);
          }                
          setErrorPopup(true);
          setLoading(false);
        }
      );      
    }
  }

      const setValidationStatus = (status) => {
        if (status == 'UNREDEEMED') {
        setIsError(false);
        setIsEmpty(false);
        setErrorMsg("");
        setIsCodeValid(true);
        setIsbtnDisabled(false);
      }
      else if (status == 'EXPIRED') {
        setIsError(true);
        setIsCodeValid(false);
        setErrorMsg("This code is expired");
      } else if (status == 'REDEEMED') {
        setIsError(true);
        setIsCodeValid(false);
        setErrorMsg("This code has already been activated. Please enter a new code.");
      } else if (status == 'INACTIVE') {
        setIsError(true);
        setIsCodeValid(false);
        setErrorMsg("This code is inactive");
      }
  }

  const regexValidation = (value) => {
    const Ahregex = /^(?:\d{6}-[A-Z]{5}(?:-[A-Z]{5}){4}|[A-Z0-9]{8}-[A-Z0-9]{4}-[A-Z0-9]{4}-[A-Z0-9]{4}-[A-Z0-9]{11}|[A-Z]{5}(?:-[A-Z]{5}){5})$/;
    if(value !== '' && value.length < 35){
     setIsError(false);
      setIsEmpty(false);
      setErrorMsg("");
    }else if (value !== '' && value.length >= 35 && (!Ahregex.test(value) || btnClicked)) {
      setIsError(true);
      setIsCodeValid(false);
      setToolTip(false);
      setErrorMsg("This code is not valid. Please enter a different code.");
    }
    else if (value && Ahregex.test(value)) {
      setTimeout(() => {
        setLoading(true);
        setIsbtnDisabled(true);
        getAccessCodeData(value).subscribe(
          (response) => {
            setEbookTitle(response?.resourceTitle);
            setLoading(false);
            setIsbtnDisabled(true);
            setValidationStatus(response?.status);
          },
          (error) => {
            setLoading(false);
            setIsError(true);
            setIsCodeValid(false);
            if (error?.data?.status == 404 && (error?.data?.detail =='Accesscode not found' || error?.data?.detail =='No product found for the given isbn')) {
              setErrorMsg("This code is not valid. Please enter a different code.");
            }else if (error?.data?.status == 404 && error?.data?.detail !=='No product found for the given isbn') {
              setErrorMsg(error?.data?.detail || "This code is not valid. Please enter a different code.");
            }else if (error?.data?.status == 404 && error?.data?.detail =='No product found for the given isbn'){
              setValidationStatus(error?.data?.accessCodeStatus);
              setEbookTitle("");
            }else {
              setErrorMsg(error?.data?.detail);
            }
          }
        );
      }, 300);
    } else if (value == '') {
      setIsError(true);
      setErrorMsg("");
    }
    // else {
    //   setIsError(true);
    //   setErrorMsg("This code is not valid. Please enter a different code.");
    //   setIsCodeValid(false);
    // }
  }

  const handleCodeChange = (e) => {
    const value = e?.target?.value || "";
    setAccessCode(value);
    setToolTip(false);
    if (value == '') {
      setIsError(false);
      setIsEmpty(false);
      setIsbtnDisabled(false);
      setIsCodeValid(false);
      setErrorMsg("");
    }
    else {
      regexValidation(value)
    }
  };

  const handleNext = () => {
    setBtnClicked(true);
    validateAccessCode();
  };

  const handleCloseBtn = () => {
    setErrorPopup(false);
    setIsError(false);
    setIsEmpty(false)
    setIsCodeValid(false);
    setErrorMsg("");
    setAccessCode("");
  }

  return (<div className="access-code-activehub">
    {loading && <Loader />}
    <h4>Enter the access code to activate your ebook</h4>
    <RedeemCodeInput
      inputtype={"text"}
      value={accessCode}
      labelClassName="titleAfter"
      onChange={handleCodeChange}
      onBlur={() => { }}
      customDataAttributes={{
        "aria-required": true,
        "maxLength": 38,
      }}
      isError={isError || isEmpty}
      isValidCode={isCodeValid}
      errorMsg={errorMsg}
      required={true}
      showClearIcon={isError}
      preventAction={toolTip}
      showTooltip={toolTip}
    />
    {(isCodeValid && ebookTitle) && <div className="ebook-title">{entities?.decode(ebookTitle)}</div>}
    <Button className="next-step" tabIndex={true ? 0 : -1} onClick={handleNext} isDisabled={isError || isbtnDisabled}>
      Activate access code
    </Button>
    <ErrorPopUp
      popupType="error"
      isOpen={openErrorPopup}
      headerText={`Error`}
      bodyText={errpopMsg}
      closeButton={"Close"}
      handleCloseButton={handleCloseBtn}
    />
  </div>)
}

export default AccessCodeActiveHub;
